<template>
    <div>
        <div class="content-caption dashed required">
            <span>资产信息</span>
            <a class="swb-btn-link" @click="selectDevc()">选择</a>
        </div>
        <div>
            <el-form :model="specificAccDto">
                <el-table ref="multipleTable" :data="specificAccDto.shopDeviceSvcSubList" border tooltip-effect="dark" style="width: 100%">
                    <el-table-column align="left" prop="title" label="名称"></el-table-column>
                    <el-table-column align="left" prop="catName" label="分类"></el-table-column>
                    <el-table-column align="left" prop="brandName" label="品牌"></el-table-column>
                    <el-table-column align="left" prop="tmpNo" label="系统编号"></el-table-column>
                </el-table>
            </el-form>
        </div>
        <div class="content-caption dashed required">
            <span>个体化配件</span>
            <a class="swb-btn-link" @click="selectAcc()">选择</a>
        </div>
        <div>
            <el-form :model="specificAccDto">
                <el-table ref="multipleTable" :data="specificAccDto.specificAccList" border tooltip-effect="dark" style="width: 100%">
                    <el-table-column align="left" prop="name" label="名称"></el-table-column>
                    <el-table-column align="left" prop="vendorSn" label="厂商序列号"></el-table-column>
                    <el-table-column align="left" prop="catName" label="分类"></el-table-column>
                    <el-table-column align="left" prop="brandName" label="品牌"></el-table-column>
                    <el-table-column align="left" prop="modelSpec" label="规格"></el-table-column>
                    <el-table-column label="操作" width="80px">
                        <template slot-scope="scope">
                            <span class="swb-btn swb-btn-link" @click="rowAcc(scope.row)">移除</span>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
        </div>
    </div>
</template>
<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, DomSizeWatcher, Routes } from '../../app.vues'
    import { openRetailComTreeSelectDlg } from '../retailer/selectDlg';
    import { selectSpecificAccDlog } from './selectDlg'
    import {showDevcSelectDlg} from '../devc/selectDlg'
    import userApi from '../../api/user'
    //
    export default {
        name: 'swb-boud-devc',
        desc: '关联设备',
        props:["selectComId","comLevel","includeSubComs"],
        data: function () {
            return {
                specificAccDto: {
                    specificAccList: [],
                    shopDeviceSvcSubList: [],
                    boundDevcId: null,
                },
                selectComId: null,
                scope: null,
            }
        },
        created: function () {
            this.getCurrentUserInfo();
        },
        methods: {
            getCurrentUserInfo: function () {
                let self = this;
                userApi.getUserInfoByContext({}, function (result, jqXhr) {
                    if(result.type == 'info') {
                        let data = result.data;
                        let scopeEntity = data.scopeEntity;
                        self.scope = scopeEntity.scopeId;
                    } else {
                        self.$message.warning(result.message);
                    }
                });
            },
            /**
             * 选择资产，给那个资产绑定个体化配件
             */
            selectDevc: function () {
                let self = this;
                let specificAccDto = self.specificAccDto;
//                let singleFilter = {
//                    cleared: false,
//                    leasible: false,
//                    retailerShopId:self.selectComId,
//                    comLevel:self.comLevel,
//                    includeSubComs:self.includeSubComs
//                };
//
//                showAssetSelectDlg({
//                    singleFilter: singleFilter,
//                    singlecheck: {isShowSelection: false},
//                    selectSingle: true,
//                    selectAll: false,
//                }, function (result) {
//                    console.log(result);
//                    // 为了显示用
//                    let shopDeviceSvcSubList = [];
//                    shopDeviceSvcSubList.push(result);
//                    specificAccDto.shopDeviceSvcSubList = Utils.merge([], shopDeviceSvcSubList);
//                    specificAccDto.boundDevcId = result.id;
//                    specificAccDto.specificAccList = Utils.merge([]);
//                    self.specificAccDto = Utils.merge({}, specificAccDto);
//                    //
//                    self.selectComId = result.retailerShopId;
//                });
                //
                let filter = {};
                filter.retailerComId = self.selectComId;
                filter.cleared = false;
                filter.leasible = false;
                let params = {
                    filter: filter,
                    checkBox: false
                };
                showDevcSelectDlg(params, function (result) {
                    // 为了显示用
                    let shopDeviceSvcSubList = [];
                    shopDeviceSvcSubList.push(result);
                    specificAccDto.shopDeviceSvcSubList = Utils.merge([], shopDeviceSvcSubList);
                    specificAccDto.boundDevcId = result.id;
                    specificAccDto.specificAccList = Utils.merge([]);
                    self.specificAccDto = Utils.merge({}, specificAccDto);
                    //
                    self.selectComId = result.retailerComId;
                });
            },
            /**
             * 选择个体化配件
             */
            selectAcc: function () {
                let self = this;
                let selectComId = self.selectComId;
                let specificAccDto = self.specificAccDto;
                let specificAccList = specificAccDto.specificAccList || [];
                let selectIds = specificAccList.pluck("id");
                selectSpecificAccDlog({
                    selectComId: selectComId,
                    selectIds: selectIds
                }, function (result) {
                    specificAccList = result;
                    specificAccDto.specificAccList = Utils.merge([], specificAccList);
                    self.specificAccDto = specificAccDto;
                })
            },
            /**
             * 删除某一个个体化配件
             */
            rowAcc: function (row) {
                let specificAccDto = this.specificAccDto;
                let specificAccList = specificAccDto.specificAccList;
                for(let i = 0; i < specificAccList.length; i++) {
                    let specificAcc = specificAccList[i];
                    if(specificAcc.id == row.id) {
                        specificAccList.splice(i, 1);
                    }
                }
                specificAccDto.specificAccList = Utils.merge([], specificAccList);
                this.specificAccDto = specificAccDto;
            },
            /**
             * 返回信息
             */
            getDlgResult: function () {
                let specificAccDto = this.specificAccDto;
                let boundDevcId = specificAccDto.boundDevcId;
                let result = {};
                if(boundDevcId == null) {
                    result.message = "请选择设备信息";
                    result.type = "warn";
                    return result;
                }
                let specificAccList = specificAccDto.specificAccList;
                if(specificAccList.length <= 0) {
                    result.message = "请选择个体化配件";
                    result.type = "warn";
                    return result;
                }
                result.data = specificAccDto;
                result.type = "info";
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/accStock/BoundDevcSpecificAcc.vue